<template>
  <div class="illustration-photos-content" id="identidade-visual-ilustracao-aplicacoes" data-search-anchor>
    <div class="illustration-photos-wrapper">      
      <h1 class="illustration-photos-title-span">{{ photosTitleSpan }}</h1>
      <h1 class="illustration-photos-title">{{ photosTitle }}</h1>
    </div>
    <div
      class="illustration-photos-card-item1"
      :style="{ backgroundImage: `url(${ImageSrc})`}"
    ></div>
    <div
      class="illustration-photos-card-item2"
      :style="{ backgroundImage: `url(${ImageSrc2})`}"
    ></div>
  </div>
</template>

<script lang="ts">
import { PageStoreContract } from '@/data/store/page.store.contract'
import IllustrationPageMixin from '@/mixins/illustration-page-mixin'
import { IllustrationPageStore } from '@/store/visual-identity-page/illustration-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({})
export default class IllustrationPhotosSection extends Mixins(IllustrationPageMixin) {
  illustrationPageStore: PageStoreContract = getModule(IllustrationPageStore, this.$store)

  get photosTitleSpan(): string {
    return this.getElementTitle(11, 0)
  }

  get photosTitle(): string {
    return this.getElementText(11, 0)
  }

  get ImageSrc(): string {
    return this.getElementMedia(11, 0)
  }

  get ImageSrc2(): string {
    return this.getElementMedia(11, 1)
  }

  async getIllustrationPage(): Promise<void> {
    await this.illustrationPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.illustrationPageStore.isLoading) {
      await this.getIllustrationPage()
    }
  }
}
</script>

<style lang="scss">
.illustration-photos-content {
  display: grid;

  width: 100%;
  max-width: 1032px;
}

.illustration-photos-wrapper {
  display: flex;
  align-items: center;
  height: 6vh;
  padding-top: 6.25rem;
  padding-bottom: 2rem;
}


.illustration-photos-title,
.illustration-photos-title-span {  
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;

  color: #000000;
}

.illustration-photos-title-span {
  margin-right: 5px;
  color: #b3b3b3;
}

.illustration-photos-card-item1,
.illustration-photos-card-item2 {
  position: relative;  

  max-width: 1032px;
  width: 100%;
  height: 590px;
  border-radius: 12px;
  
  background-repeat: no-repeat;
  background-position: center;  
}


.illustration-photos-card-item2 {  
  margin-top: 1rem;
  margin-bottom: 2rem;  
}
</style>
